import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getHistory(userId) {
        try
        {            
            const response = await axios.get(`LeavesAllocation/${userId}/leaves-benefits-history`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation getHistory api error')
            throw error
        }
    },
    async getAvailable(transDate) {
        try
        {            
            const response = await axios.get(`LeavesAllocation/mybalances/${transDate}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation getAvailable api error')
            throw error
        }
    },
    async getAvailableByUser(userId, transDate) {
        try
        {            
            const response = await axios.get(`LeavesAllocation/balances/${userId}/${transDate}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation getAvailable api error')
            throw error
        }
    },
    async getAvailableByFY(fiscalYear) {
        try
        {            
            const response = await axios.get(`LeavesAllocation/mybalances/fy/${fiscalYear}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation getAvailableByFY api error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`LeavesAllocation`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation add api error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`LeavesAllocation`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation update api error')
            throw error
        }
    },
    async delete(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/delete/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation delete api error')
            throw error
        }
    },
    async forReview(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/forReview/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation forReview api error')
            throw error
        }
    },
    async approve(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/approve/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation approve api error')
            throw error
        }
    },
    async reject(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/reject/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation reject api error')
            throw error
        }
    },
    async rejectDelete(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/reject_delete/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation rejectDelete api error')
            throw error
        }
    },
    async undoDelete(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/undo_delete/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation undoDelete api error')
            throw error
        }
    },
    async approveDelete(leavesAllocationId) {
        try
        {            
            const response = await axios.post(`LeavesAllocation/approve_delete/${leavesAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('LeavesAllocation approveDelete api error')
            throw error
        }
    }
}